import {Controller} from "@hotwired/stimulus"

// Lets a report card switch its number scale (units / thousands / lakhs /
// millions / crores) in real time. Selecting an option writes
// `data-report-scale` onto the card element and pushes the new scale to every
// `currency` outlet inside this card. Each cell re-formats against the scale
// of the card it lives in, so cards switch independently. Virtualised
// SlickGrid rows that mount later read the scale on connect (via the ancestor
// attribute) and also receive a push via `currencyOutletConnected`.
export default class extends Controller {
  static targets = ["label", "option"]
  static outlets = ["currency"]

  select(event) {
    const button = event.currentTarget
    const scale  = button.dataset.scaleValue
    const label  = button.dataset.scaleLabel
    if (!scale) return

    this.element.setAttribute('data-report-scale', scale)

    if (this.hasLabelTarget && label) {
      this.labelTarget.textContent = label
    }

    this.markActive(scale)
    this.currencyOutlets.forEach((outlet) => outlet.applyScale(scale))
  }

  currencyOutletConnected(outlet) {
    const scale = this.element.getAttribute('data-report-scale')
    if (scale) outlet.applyScale(scale)
  }

  // Highlight the chosen scale in the dropdown list and clear the others, so
  // the menu always shows which scale the card is currently rendered at.
  markActive(scale) {
    this.optionTargets.forEach((option) => {
      const active = option.dataset.scaleValue === scale
      option.classList.toggle('bg-indigo-50', active)
      option.classList.toggle('text-indigo-700', active)
      option.classList.toggle('font-semibold', active)
      option.classList.toggle('text-gray-700', !active)
      const check = option.querySelector('[data-scale-check]')
      if (check) check.classList.toggle('invisible', !active)
    })
  }
}
